import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { blendApi, House, Target } from "./api";
import { GENDER_AR } from "./ui";

export default function HousesPage() {
  const nav = useNavigate();
  const [houses, setHouses] = useState<House[]>([]);
  const [selected, setSelected] = useState<House | null>(null);
  const [targets, setTargets] = useState<Target[]>([]);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    blendApi.houses().then(setHouses).catch((e) => setErr(String(e.message || e)));
  }, []);

  useEffect(() => {
    if (!selected) return;
    blendApi.targets({ house: selected.house })
      .then(setTargets)
      .catch((e) => setErr(String(e.message || e)));
  }, [selected]);

  if (err) return <div className="bl-sub py-8 text-center" style={{ color: "var(--bl-danger)" }} data-testid="houses-error">{err}</div>;

  if (selected) {
    return (
      <div data-testid="house-detail">
        <button className="bl-btn ghost mb-3" onClick={() => setSelected(null)} data-testid="house-back-btn">→ كل البيوت</button>
        <div className="bl-card mb-4">
          <div className="bl-eyebrow">DNA البيت</div>
          <div className="bl-title bl-en">{selected.house}</div>
          <div className="bl-sub mt-1" data-testid="house-dna">{selected.dna}</div>
          <div className="bl-sub mt-1">{selected.count} عطر في المكتبة</div>
        </div>
        <div className="bl-grid">
          {targets.map((t) => (
            <div key={t.id} className="bl-card hoverable" data-testid={`house-target-${t.id}`}
              onClick={() => nav(`/pureh/blend/target/${t.id}`)}>
              <div className="font-extrabold bl-en">{t.name}</div>
              <div className="bl-sub bl-en">{t.year} · <span className="bl-pill">{GENDER_AR[t.gender]}</span></div>
              <div className="mt-1"><span className="bl-pill">{t.family_ar}</span></div>
              <div className="bl-sub bl-en mt-2" style={{ fontSize: 11 }}>{t.dna}</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="bl-grid" data-testid="houses-grid">
      {houses.map((h) => (
        <div key={h.house} className="bl-card hoverable" data-testid={`house-card-${h.house.replace(/\s+/g, "-")}`}
          onClick={() => setSelected(h)}>
          <div className="flex items-center justify-between">
            <div className="font-extrabold bl-en" style={{ fontSize: 16 }}>{h.house}</div>
            <span className="bl-pill">{h.count} عطر</span>
          </div>
          <div className="bl-sub mt-2">{h.dna}</div>
        </div>
      ))}
      {!houses.length && <div className="bl-sub py-8 text-center" data-testid="houses-loading">جارٍ التحميل…</div>}
    </div>
  );
}
